<template>
  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <VSelect
          :options="categories"
          :rules="{ required: true }"
          placeholder="Category *"
          fieldset-class="category-select"
          vid="item.invoiceType"
          name="Category"
          @update:model-value="onUpdateCategory"
        />
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group currency-dropdown">
        <Dropdown
          :with-search="true"
          :options="currencies"
          :dropdown-text="`${selectedCurrency.icon} ${selectedCurrency.value}`"
          @selected="onUpdateCurrency"
        />
      </div>
    </div>
    <div class="col-md-6 mt-3 mt-md-0">
      <div class="custom-alert">
        <div class="custom-alert-image">
          <mdicon name="Alert" />
        </div>
        <div class="custom-alert-text">
          Customs declaration must be filled out correctly. If in doubt, please read more
          <router-link :to="{ name: PROFORMA_INVOICE }" target="_blank"> here </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { SelectOptions } from '@/types/Components/SelectOptions'
import type { AssignmentCreationData } from '@/types/Models/Assignment'
import { computed, type ComputedRef, defineComponent, ref, type Ref } from 'vue'
import { getProformaInvoiceTypes } from '@/services/Utils'
import { useAssignmentFormStore } from '@/store/assignmentForm'
import { PROFORMA_INVOICE } from '@/types/router'
import VSelect from '@/views/Components/Elements/Form/VSelect.vue'
import Dropdown from '@/views/Components/Elements/Dropdown.vue'
import allCurrencies from '@/assets/files/currencies.json'

export default defineComponent({
  name: 'DeclarationData',
  components: { VSelect, Dropdown },
  setup() {
    const assignmentFormStore = useAssignmentFormStore()

    const categories: SelectOptions[] = Object.values(getProformaInvoiceTypes())

    const currencies: Ref<SelectOptions[]> = ref(
      allCurrencies.map((currency) => ({
        text: `${currency.icon} ${currency.value}`,
        value: currency.value,
      })),
    )
    const assignment: ComputedRef<AssignmentCreationData> = computed(
      () => assignmentFormStore.assignment,
    )

    const selectedCurrency = allCurrencies[0]

    const onUpdateCategory = (value: string) => {
      assignmentFormStore.setFields({ item: { ...assignment.value.item, invoiceType: value } })
    }
    const onUpdateCurrency = (currency: SelectOptions) => {
      assignmentFormStore.setFields({
        item: { ...assignment.value.item, currency: String(currency.value ?? '') },
      })
    }

    return {
      categories,
      currencies,
      selectedCurrency,
      onUpdateCategory,
      onUpdateCurrency,
      PROFORMA_INVOICE,
    }
  },
})
</script>
